import { render, staticRenderFns } from "./material-details.vue?vue&type=template&id=a98f13f0&scoped=true&"
import script from "./material-details.vue?vue&type=script&lang=js&"
export * from "./material-details.vue?vue&type=script&lang=js&"
import style0 from "./material-details.vue?vue&type=style&index=0&id=a98f13f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98f13f0",
  null
  
)

export default component.exports